import React, { Fragment } from "react";
import { DollarSign, Tag, ShoppingBag, Sun } from "react-feather";
import CountUp from "react-countup";
import { chart1, chartsmall } from "../../../data/default";
import configDB from "../../../data/customizer/config";
import {
  TotalVisits,
  TotalSale,
  TotalValue,
  TotalTax,
  TotalEarning,
  ProductionValuation
} from "../../../constant";
const primary =
  localStorage.getItem("primary_color") || configDB.data.color.primary_color;
const secondary =
  localStorage.getItem("secondary_color") ||
  configDB.data.color.secondary_color;

const EventCharts = () => {
  return (
    <Fragment>
      <div className="col-md-4">
        <div className="card">
          <div className="card-body">
            <div className="chart-widget-dashboard">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <h5 className="mt-0 mb-0 f-w-600">
                    <span>
                      <CountUp className="counter" end={568} />
                    </span>
                  </h5>
                  <p>
                    {TotalVisits}
                  </p>
                </div>
                <Tag />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="card">
          <div className="card-body">
            <div className="chart-widget-dashboard">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <h5 className="mt-0 mb-0 f-w-600">
                    <span>
                      <CountUp className="counter" end={330} />
                    </span>
                  </h5>
                  <p>Total Patient</p>
                </div>
                <ShoppingBag />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="card">
          <div className="card-body">
            <div className="chart-widget-dashboard">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <h5 className="mt-0 mb-0 f-w-600">
                    <span>
                      <CountUp className="counter" end={30000} />
                    </span>
                  </h5>
                  <p>Total Income</p>
                </div>
                <Sun />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EventCharts;
